// One launchable item. Presentational: it launches via the `onOpen` handler it is
// given (the original openItem) and never decides access.
//   variant "card"  – dashboard card
//   variant "app"   – portal / page / admin tool tile (app-launcher on phones)
//   variant "quick" – compact Quick Access entry
//   variant "row"   – search result row
import React, { memo } from "react";
import { ArrowRight, ExternalLink, Star } from "lucide-react";
import { CATEGORY_LABELS } from "../workspaceCategories";

const AppTile = ({ item, variant = "app", favorite = false, canFavorite = true, onOpen, onToggleFavorite, showCategory = false }) => {
  const Icon = item.icon;
  const LinkIcon = item.external ? ExternalLink : ArrowRight;
  const label = item.external ? `${item.title} (opens in new tab)` : item.title;
  const showStar = Boolean(item.favoritable && onToggleFavorite && variant !== "quick");

  return (
    <div className={`cc-tile cc-tile--${variant}`} data-favorite={favorite ? "true" : "false"} data-item-id={item.id}>
      <button type="button" className="cc-tile__main" aria-label={label} onClick={() => onOpen(item)}>
        <span className={`cc-tile__icon ${item.iconBg}`} aria-hidden="true">
          <Icon className={item.iconColor} />
        </span>
        <span className="cc-tile__text">
          <span className="cc-tile__title">{item.title}</span>
          {item.description ? <span className="cc-tile__desc">{item.description}</span> : null}
        </span>
        {showCategory ? <span className="cc-tile__cat">{CATEGORY_LABELS[item.category]}</span> : null}
        <span className="cc-tile__go" aria-hidden="true">
          <LinkIcon />
        </span>
      </button>

      {showStar ? (
        <button
          type="button"
          className="cc-tile__star"
          aria-pressed={favorite}
          aria-label={favorite ? `Remove ${item.title} from Quick Access` : `Add ${item.title} to Quick Access`}
          title={favorite ? "Remove from Quick Access" : canFavorite ? "Add to Quick Access" : "Quick Access is full"}
          disabled={!favorite && !canFavorite}
          onClick={() => onToggleFavorite(item)}
        >
          <Star aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
};

export default memo(AppTile);
